import { useForm } from 'react-hook-form';
import {
  categoryQuery,
  productGroupCodeQuery,
  productTypeQuery,
} from '../../../../services/react-query/optionMasterQuery';
import { useManagementData } from './onGetOptions';
import { useAddProduct } from './useAddProduct';
import { handleSubmitForm } from '../func/handleSubmitform';
import { useEffect } from 'preact/hooks';

export const useAddProductList = () => {
  const { control, setValue, getValues, watch, reset, handleSubmit } = useForm();
  const selectedBrandId = watch('mobileBrandId');
  const selectedCategoryId = watch('categoryId');
  const { mutate: onAddProduct, isPending: isLoadingAddProduct } = useAddProduct({ reset });
  const { data: categoryList, isPending: loadingCategory } = categoryQuery();
  const { brandList, modelList, loadingBrand, loadingModel } = useManagementData(
    selectedBrandId || '',
  );
  const { data: productTypeList, isPending: loadingProductType } = productTypeQuery();
  const { data: productGroupCodeList, isPending: loadingProductGroupCode } =
    productGroupCodeQuery();

  useEffect(() => {
    if (selectedCategoryId && categoryList) {
      const selectedCategory = categoryList?.find(
        (category) => category?.value === selectedCategoryId,
      );
      if (selectedCategory && selectedCategory.defaultWarrantyPeriod) {
        setValue('warrantyPeriod', selectedCategory.defaultWarrantyPeriod);
      }
    }
  }, [selectedCategoryId, categoryList, setValue]);

  const onSubmit = (value) => handleSubmitForm(value, onAddProduct);

  return {
    control,
    setValue,
    getValues,
    categoryList,
    brandList,
    modelList,
    loadingCategory,
    loadingBrand,
    loadingModel,
    productTypeList,
    productGroupCodeList,
    loadingProductType,
    loadingProductGroupCode,
    onSubmit,
    handleSubmit,
    isLoadingAddProduct,
  };
};
